module.exports = __webpack_public_path__ + "static/media/pezotettix_giornae.3b726cd0.jpg";